'use client';

import 'swiper/css';

import { useCssValue } from '@actr/style/src/hooks/use-css-value';
import { themeContract } from '@actr/style/src/themes';
import { observer } from 'mobx-react-lite';
import { stripUnit } from 'polished';
import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';

import Tag from '@/components/avia/routes-in-city/tags/tag';

import * as Styled from './style.css';

export type TagsProps = {
    tags: {
        name: string;
        price: number;
    }[];
}

const Tags: React.FC<TagsProps> = ({ tags }) => {
  const marginX2s = useCssValue(themeContract.margin.x2s);

  function renderMobileTags() {
    return (
      <div className={Styled.MobileTagsWrapp}>
        <Swiper
          className={Styled.TagsSwiper}
          spaceBetween={+stripUnit(marginX2s)}
          slidesPerView="auto">
          { tags.map((tag, i) => (
            <SwiperSlide className={Styled.TagSwiperSlide} key={i}>
              <Tag key={i} name={tag.name} price={tag.price} />
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    );
  }

  function renderDesktopTags() {
    return (
      <div className={Styled.DesktopTags}>
        {tags.map((tag, i) => (<Tag key={i} name={tag.name} price={tag.price} />))}
      </div>
    );
  }

  return (
    <div className={Styled.TagsWrapper}>
      <div className={Styled.MainInfo}>
        <div className={Styled.Tags}>
          {renderDesktopTags()}
          {renderMobileTags()}
        </div>
      </div>
    </div>
  );
};

export default observer(Tags);
